// extracted by mini-css-extract-plugin
export default {"composer":"composer__T8ORx"};